import React, { forwardRef, useCallback, useRef } from 'react';
import clsx from 'clsx';
import { mergeRefs } from 'react-merge-refs';
import { useStyles } from './Dialog.styles';

export interface IDialogProps {
    children: React.ReactNode;
    open: boolean;
    onClose?: (returnValue: string|undefined) => void;
    className?: string;
    id?: string;
}

const Dialog = forwardRef<HTMLDialogElement, IDialogProps>((props, ref) => {

    const styles = useStyles();

    const localRef = useRef<HTMLDialogElement>(null);

    const handleClose = useCallback(() => {
        props.onClose?.(localRef.current?.returnValue);
    }, [ props.onClose ]);

    return (
        <dialog
            id={props.id}
            className={clsx(styles.dialog, props.className)}
            ref={mergeRefs([ localRef, ref ])}
            open={props.open}
            onClose={handleClose}
        >
            {props.children}
        </dialog>
    );
});
Dialog.displayName = 'Dialog';

export { Dialog };
